import { SerializedError } from "@reduxjs/toolkit"
import { FetchBaseQueryError } from "@reduxjs/toolkit/query"

type ErrorResponseData = {
  message?: string
  description?: string
  errors?: unknown
}

const extractErrorMessages = (value: unknown): string[] => {
  if (typeof value === "string") return value ? [value] : []
  if (Array.isArray(value)) return value.flatMap(extractErrorMessages)
  if (!value || typeof value !== "object") return []

  return Object.values(value).flatMap(extractErrorMessages)
}

const getValidationErrorMessage = (errors?: ErrorResponseData["errors"]) => {
  return extractErrorMessages(errors).join("\n")
}

const getErrorMessage = (
  error: SerializedError | FetchBaseQueryError | undefined,
  errorProp: "message" | "description" = "message",
  defaultMessage = "Something went wrong",
) => {
  if (!error) {
    return ""
  }

  if ("status" in error && "data" in error) {
    const data = error.data as ErrorResponseData
    return getValidationErrorMessage(data.errors) || data[errorProp] || data.message || defaultMessage
  }

  if ("status" in error && "error" in error && !("message" in error)) {
    return error.error
  }

  return error.message as string
}

export default getErrorMessage
